module.exports = __webpack_public_path__ + "img/store-alt-slash.8bb489dd.svg";